/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SeverityEnum } from './severityEnum';


export interface ProviderComponentHeathSummary { 
    /**
     * Count of the occurrences
     */
    count?: number;
    severity?: SeverityEnum;
}
export namespace ProviderComponentHeathSummary {
}


